import React, { memo } from "react";
import { useParams } from "react-router-dom";
import { PageTemplate } from "../../../components/templates";
import { OUTPUT } from "../../../enums";
import EnquadramentoAdd from "../_components/EnquadramentoAdd";
import CenarioAdd from "../_components/CenarioAdd";

const ReportSettingsAdd = memo(() => {
  const params = useParams();

  const OUTPUTS = {
    enquadramento: EnquadramentoAdd,
    stresstest: CenarioAdd,
  };

  const AddComponent = OUTPUTS[params.output];

  const { title, subtitle } = OUTPUT[params.output].config_add;

  return (
    <PageTemplate
      title={title}
      subtitle={subtitle}
      scrollable={false}
      maxWidth="md"
    >
      <AddComponent />
    </PageTemplate>
  );
});

export default ReportSettingsAdd;
